import axios from 'axios'

class TestimonialRepository {
  getTestimonials (count) {
    const url = count ? `${BASE_URL}/testimonials?count=${count}` : `${BASE_URL}/testimonials`
    return axios.get(url)
    .then(response => {
      if (count) return response.data[Object.keys(response.data)[0]]
      else return response.data
    })
    .catch(error => console.log(error))
  }
}

export default new TestimonialRepository()



// WEBPACK FOOTER //
// ./src/data/testimonial.repository.js